// Handles a single interactive clock element
class InteractiveTimeItem {
  constructor({ element }) {
    this.element = element;
    this.lastTime = "";
    this.update();
  }

  // Updates the time if it has changed
  update() {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const currentTime = `${hours}:${minutes}`;

    if (this.lastTime !== currentTime) {
      this.renderTime(hours, minutes);
      this.lastTime = currentTime;
    }

    // Schedule next check
    setTimeout(() => this.update(), 1000);
  }

  // Renders the time using <i data-s="symbol"> elements
  renderTime(hours, minutes) {
    const fragment = document.createDocumentFragment();

    hours.split("").forEach(symbol => {
      fragment.appendChild(this.createSymbolElement(symbol));
    });

    fragment.appendChild(this.createSymbolElement("s")); // Separator

    minutes.split("").forEach(symbol => {
      fragment.appendChild(this.createSymbolElement(symbol));
    });

    this.element.innerHTML = "";
    this.element.appendChild(fragment);
  }

  // Creates an <i data-s="..."> element
  createSymbolElement(symbol) {
    const elem = document.createElement("i");
    elem.dataset.s = symbol;
    return elem;
  }
}

// Manages multiple interactive time elements on the page
class InteractiveTimeController {
  constructor(settings) {
    this.settings = settings;
    this.items = [];
  }

  // Initializes new elements that haven't been processed
  bindNew() {
    this.getUnboundElements().forEach(element => {
      const item = new InteractiveTimeItem({ element });
      this.items.push(item);
    });
  }

  // Returns all matching elements that are not yet initialized
  getUnboundElements() {
    const all = document.querySelectorAll(this.settings.selectors.element);
    const initialized = this.items.map(item => item.element);
    return Array.from(all).filter(el => !initialized.includes(el));
  }
}

export default InteractiveTimeController;
